import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  JainPanchang,
  JainPanchangPayload,
} from "@project/types/jain-panchang";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/jain-panchang`;
const SILENT: RequestConfig = { showNotification: false };

class JainPanchangService {
  listJainPanchangPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<JainPanchang>> => {
    return fetchListPage<JainPanchang>(`${BASE}/`, query);
  };

  getJainPanchang = async (id: number): Promise<JainPanchang | undefined> => {
    const data = await get<ApiItemResponse<JainPanchang> | JainPanchang>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createJainPanchang = async (
    payload: JainPanchangPayload
  ): Promise<JainPanchang | undefined> => {
    const data = await post<
      ApiItemResponse<JainPanchang> | JainPanchang,
      JainPanchangPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  updateJainPanchang = async (
    id: number,
    payload: Partial<JainPanchangPayload>
  ): Promise<JainPanchang | undefined> => {
    const data = await patch<
      ApiItemResponse<JainPanchang> | JainPanchang,
      Partial<JainPanchangPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteJainPanchang = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const jainPanchangService = new JainPanchangService();
